class User {
    constructor(data) {
        Object.assign(this, data);
        console.log(this);
    }
    static create(data) {
        return data ? new User(data) : new AnonymousUser();
    }
    isAnonymous() {
        return false;
    }
    canView(componentPath) {
        return Object.keys(this.permissions || {}).find(k => {
            if (Array.isArray(componentPath)) {
                return componentPath.some(path => k === path);
            }
            return k === componentPath;
        });
    }
    canChange(componentPath) {
        if (Array.isArray(componentPath)) {
            return componentPath.some(path => this.canChange(path));
        }
        const permissions = this.permissions || {};
        const permission = permissions[componentPath];
        return Boolean(permission && permission === 'change');
    }
}

class AnonymousUser {
    isAnonymous() {
        return true;
    }
    canView() {
        return false;
    }
    canChange() {
        return false;
    }
}

export default User;
